
define('eteration/widgets/ui-recaptcha',[ 'jquery', 'knockout', 'eteration/eteration-ajax', 'eteration/eteration-i18n', 'common/recaptcha-constants' ],
		function($, ko, etrAjax, i18n, recaptchaConstants) {

			var deferred = jQuery.Deferred(), 
				promise = deferred.promise(), 
				publicKey = '6LfvwDMUAAAAALBHKMRVZPZmKygAvKtTQxQ1TCcI', 
				recaptcha, 
				widgetId;

			window.thyRecaptchaApiLoaded = function() {
				recaptcha = window.grecaptcha;
				deferred.resolve(recaptcha);
			};		
			
			function getRecaptcha() {
				if (!!recaptcha) {
					return $.when(recaptcha);
				}
				return promise;
			}

			
			function create(elm, key, fn, conf) {
				conf.callback = fn;
				conf.id = elm.id;
				conf.size = "inline";
				return getRecaptcha().then(function(recaptcha) {
					return recaptcha.render(elm, conf);
				});
			}
			

			function addRecaptchaScript() {
				if (!window.recaptchaScriptLink) {
					$($('head')[0])
							.append(
									'<script src="' + recaptchaConstants.domain + '?onload=thyRecaptchaApiLoaded&render=explicit&hl=' + i18n.getUserLocale() + '" async defer></script>');
					window.recaptchaScriptLink = true;
				}
			}
			
			if (window.grecaptcha) {
				window.thyRecaptchaApiLoaded();
			}
			
			
			
			ko.bindingHandlers['recaptcha'] = {
				init : function(element, valueAccessor, allBindings) {
					addRecaptchaScript();
					if ($(window).width() < 360) {
						$(element).css({
							width : '90%',
							margin : 'auto'
						})
					}
					var key = allBindings.get('key') || publicKey, callback = function(gRecaptchaResponse) {
						
						var value = ko.utils.unwrapObservable(valueAccessor());
						value.response(gRecaptchaResponse);
						
						var onSuccess = allBindings.get('onSuccess')
								|| undefined, onExpire = allBindings
								.get('onExpire')
								|| undefined;
						if (onSuccess)
							onSuccess(gRecaptchaResponse);

						setTimeout(function() {
							onExpire(widgetId);
						}, 2 * 60 * 1000);
					};
					
					create(element, key, callback, {
						theme : allBindings.get('theme') || null,
						tabindex : allBindings.get('tabindex') || null,
						id	: allBindings.get('id') || element.id,
						callback : callback,
						sitekey: key,
						element: element

					}).then(
							function(widgetId) {
								var onCreate = allBindings.get('onCreate') || undefined;
								if (onCreate)
									onCreate(widgetId);
								this.widgetId = widgetId;
							});
				}
			};

			ko.virtualElements.allowedBindings['recaptcha'] = true;
		});